import { pushUserData } from '../../utils/gtm/GTMService';
import axiosInstance from '../../utils/axios';
import { Profile, JWTPayload } from './interface';

export function decodeJWT(token: string): JWTPayload | null {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace('-', '+').replace('_', '/');
    const decodedToken = JSON.parse(atob(base64));
    return decodedToken as JWTPayload;
  } catch (error) {
    console.error('Failed to decode JWT', error);
    return null;
  }
}

export const fetchProfile = async (
  accessToken: string,
  userUUID: string,
): Promise<Profile> => {
  try {
    const response = await axiosInstance.get<Profile>(
      `/users/sidebar?userUUID=${userUUID}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    pushUserData({
      email_address: response.data.email,
      phone_number: response.data.phoneNumber,
      first_name: response.data.firstname,
      last_name: response.data.lastname,
      street: response.data.street,
      city: response.data.city,
      zip_code: response.data.postalCode,
      country: response.data.country,
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};
